import React, { PureComponent } from 'react'
import { Link } from 'react-router'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Helmet from 'react-helmet'
import marked from 'marked'
import * as actions from '../../actions'
import { doTrack } from '../../helpers/TaggingSerializer'

import './HelpHome.scss'

import LoadingWheel from '@argos/loading-wheel'
import Alert from '@argos/alert'
import SearchBar from '../../components/SearchBar/SearchBar'
import CategoryMenu from '../../components/CategoryMenu/CategoryMenu'
import FAQLists from '../../components/FAQLists/FAQLists'
import StoreLocator from '../../components/StoreLocator/StoreLocator'
import staticPopularFAQs from '../../config/popularFAQs.json'

class HelpHome extends PureComponent {
  static waitForDataServer (dispatch, params, req, res) {
    return Promise
      .all([
        // dispatch(actions.fetchPopularFAQs(true)),
        dispatch(actions.fetchAlertContent(true))
      ])
  }

  componentDidMount () {
    const { actions, popularfaqs, sidebar } = this.props // eslint-disable-line

    // if (!popularfaqs.length) actions.fetchPopularFAQs()
    if (!sidebar.length) actions.fetchSidebarNav() // preload sidebar
    actions.fetchAlertContent()

    this.fireAnalytics()
  }

  fireAnalytics = () => {
    if (window.digitalData) {
      window.digitalData.page.pageInfo.pageName = 'ar:help:'
      window.digitalData.page.pageInfo.templateTitle = 'help_landingPage'
    }

    doTrack('help_initialLoad')
  }

  render () {
    const { alert, popularfaqs, popularfaqsLoading } = this.props // eslint-disable-line
    const ccn = 'home'
    const metaData = {
      title: 'Help & FAQs | Go Argos',
      meta: [{
        name: 'description',
        content: 'Get Set for Help & FAQs. Find the answers to all your questions. Same Day delivery £3.95, or fast store collection. Go Argos'
      }, {
        name: 'keywords',
        content: ''
      }, {
        name: 'canonical',
        content: 'https://www.argos.co.uk/help/'
      }]
    }

    let faqs
    if (staticPopularFAQs.length) {
      // @Todo - Load static popular FAQs for now until we sort out the CMS behind Help FAQs
      faqs = <FAQLists title='Top 10 FAQs' faqs={staticPopularFAQs} />
    } else if (popularfaqsLoading) {
      faqs = <div className='faq-loader'><LoadingWheel contained /></div>
    } else {
      faqs = (
        <div className='faq-loader'>
          <Alert backgroundColor='mauve' borderColor='mauve' textColor='white'>
            Error loading FAQs, please try again later
          </Alert>
        </div>
      )
    }

    return (
      <div className='home helpfaq help-main-tpl'>
        <div id='helpfaqcontent' tabIndex='-1' />
        <Helmet {...metaData} />

        <div className='container-fluid help-header'>
          <div className='container text-center'>
            <h2 className='h1 title'>How can we help?</h2>
            <SearchBar searchHeader />
          </div>
        </div>
        <div className='container'>
          {
            alert && <div className={ccn + '__alert-container'}>
              <Alert backgroundColor='white' borderColor='red' textColor='red'>
                <span dangerouslySetInnerHTML={{ __html: marked(alert) }} />
              </Alert>
            </div>
          }
          <div className={ccn + '__manage-orders'}>
            <h3 className={ccn + '__manage-orders-title font-bold'}>Manage your orders</h3>
            <p className={ccn + '__manage-orders-content'}>View details and manage your current or previous orders</p>
            <a className={ccn + '__manage-orders-cta button button--secondary'} href='https://www.argos.co.uk/webapp/wcs/stores/servlet/OrderSummary?tag=ar:help:managerecentorders'>Manage recent orders</a>
          </div>
          <div className='tiles-container'>
            <CategoryMenu />
          </div>

          <div className='xs-row xs-row--negative md-row'>
            <div className='xs-12 md-8'>
              { faqs }
            </div>
            <Link className={ccn + '__promo xs-12 md-4'} to='/help/promotional-codes/'>
              <p className={ccn + '__promo__title'}>Save, save, save while you <br />spend, spend, spend</p>
              <p className={ccn + '__promo__cta'}>Discover our promo codes</p>
            </Link>
          </div>

          <StoreLocator />

          <div className={ccn + '__bottom'}>
            <Link className={ccn + '__bottom__link ' + ccn + '__bottom--contact-us'} to='/help/contact-us/'>
              <span className='argos-icon icon-UIE-LeaveFeedback' />
              <p className={ccn + '__bottom__title'}>Still stuck?</p>
              <p className={ccn + '__bottom__cta'}>Contact us</p>
            </Link>
            <a className={ccn + '__bottom__link ' + ccn + '__bottom--your-account'} href='https://www.argos.co.uk/webapp/wcs/stores/servlet/OrderSummary'>
              <span className='argos-icon icon-UIE-Account' />
              <p className={ccn + '__bottom__title'}>Check Your Account</p>
              <p className={ccn + '__bottom__cta'}>Your orders</p>
            </a>
          </div>
        </div>
      </div>
    )
  }
}

HelpHome.propTypes = {
  alert: PropTypes.string,
  popularfaqs: PropTypes.array,
  popularfaqsLoading: PropTypes.bool,
  popularfaqsError: PropTypes.bool,
  sidebar: PropTypes.array,
  actions: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    alert: state.help.alert,
    popularfaqs: state.faq.popularfaqs,
    popularfaqsLoading: state.faq.popularfaqsLoading,
    popularfaqsError: state.faq.popularfaqsError,
    sidebar: state.help.sidebar
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(HelpHome)
